export default "__VITE_ASSET__DsHcFC01__"